import { render } from "./ValueFromRegExForm.vue?vue&type=template&id=2af52610&ts=true"
import script from "./ValueFromRegExForm.vue?vue&type=script&lang=ts"
export * from "./ValueFromRegExForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__